import { setGlobalApiKey } from "../apikey";
import { DiscordToRoblox, RobloxToDiscord } from "./search";

export default {
  setGlobalApiKey,
  DiscordToRoblox,
  RobloxToDiscord,
};
